var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full absolute top-0 left-0 h-full pr-0 sm:pl-0 sm:pr-0 pt-0 pb-0 flex-col inline-flex sm:inline-flex"},[_c('div',{staticClass:"w-full h-full bg-gray-900 flex-col inline-flex sm:inline-flex"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }